import { Component, inject, Input, input } from '@angular/core';
import { Router } from '@angular/router';
import { Car } from '../../models/car-model';
import { Statuses } from '../../shared/constants/status.constants';
import { Plans } from '../../shared/constants/plan.constants';

@Component({
  selector: 'app-car-item',
  standalone: false,
  templateUrl: './car-item.component.html',
  styleUrl: './car-item.component.scss',
})
export class CarItemComponent {
  @Input() car!: Car;
  listId = input<string>('carList');

  private router = inject(Router);

  statuses = Statuses;
  plans = Plans;

  goToDetails(carId: number): void {
    this.router.navigate(['/cars', carId]);
  }

  isSponsered(): boolean {
    return this.car.isSponsered && new Date(this.car.sponseredExpireDate) > new Date();
  }
}
